import create from "zustand";
var defaultState = {
    newFolderName: null,
    renaming: {
        initialFileName: null,
        newFileName: null,
    },
    uploading: {
        files: null,
        currentFileUploadPercentage: null,
        currentFileIndex: null,
    },
    path: "/",
    selectedFiles: [],
    tablePreferences: {},
};
export var useFileExplorerStore = create(function () { return defaultState; });
export var resetStore = function () {
    useFileExplorerStore.setState(defaultState);
};
export var resetUploadState = function () {
    useFileExplorerStore.setState({
        uploading: {
            files: null,
            currentFileUploadPercentage: null,
            currentFileIndex: null,
        },
    });
};
